import type { FeatureGroup } from '../../../types';
import { CRM_FEATURE_GROUP } from '../group';

export const CRM_DASHBOARD_FEATURE_GROUP: FeatureGroup = {
  guid: 'c7d2e5b8-1a43-4c69-8b27-6e9f1d2a01ff',
  name: 'crm_dashboard',
  description: 'The CRM dashboard',
  product: 'crm',
  parentGuid: CRM_FEATURE_GROUP.guid,
};
